"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Enable2FAForm = _interopRequireDefault(require("./Enable2FAForm"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
require("./Enable2FAModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Enable2FAModal = function Enable2FAModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  var GoogleQRCode = props.GoogleQRCode,
    handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    isOpen = props.isOpen,
    close = props.close,
    changeFieldValue = props.changeFieldValue,
    userName = props.userName;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Enable Two-Factor Authentication"),
    onCancel: function onCancel() {
      close();
      changeFieldValue('enableTwoFactorAuth', 'use2FA', false);
    },
    close: close
  }, /*#__PURE__*/_react["default"].createElement(_Enable2FAForm["default"], {
    userName: userName,
    GoogleQRCode: GoogleQRCode,
    handleSubmit: handleSubmit,
    submitting: submitting
  }));
};
Enable2FAModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
Enable2FAModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func
};
var _default = exports["default"] = Enable2FAModal;